"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommsIcon = void 0;
const react_1 = __importDefault(require("react"));
const SVGIcon_1 = require("../SVGIcon");
const CommsIcon = props => (react_1.default.createElement(SVGIcon_1.SVGIcon, Object.assign({}, props, { viewBox: "2 2 20 20" }),
    react_1.default.createElement("path", { 
        // opacity="0.4"
        d: "M9 8H5.00021C5.00021 8 4.00021 8 4.00021 9L4.00017 10C3.44789 10 3 10.4477 3 11V12C3 12.5523 3.44772 13 4 13L4 14C4 15 5.00024 15 5.00024 15H6V18.5C6 18.7761 6.22386 19 6.5 19H7.5C7.77614 19 8 18.7761 8 18.5V15H9V8Z" }),
    react_1.default.createElement("path", { d: "M16.5262 5H17.5002C17.7764 5 18.0002 5.22386 18.0002 5.5V17.5C18.0002 17.7761 17.7766 18 17.5005 18H16.6179C16.2392 18 15.893 17.7864 15.6735 17.4777C15.0625 16.6182 13.5708 15 11.0002 15H10V8H11.0002C13.3756 8 14.9593 6.36438 15.6903 5.42423C15.8924 5.16427 16.1969 5 16.5262 5Z" }),
    react_1.default.createElement("path", { d: "M19 10C20.1046 10 21 10.8954 21 12C21 13.1046 20.1046 14 19 14V10Z" })));
exports.CommsIcon = CommsIcon;
exports.default = exports.CommsIcon;
